import { SVGProps, memo } from 'react';

const WarningIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={props.width ?? "14"} height={props.height ?? "14"} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="7" cy="6.82617" r="6" fill={props.fill ?? "#D32F2F"} stroke="white"/>
        <path d="M7.48349 3.66113L7.41246 7.88841H6.5886L6.51758 3.66113H7.48349ZM7.00053 9.99068C6.82534 9.99068 6.67501 9.92794 6.54954 9.80247C6.42406 9.67699 6.36133 9.52666 6.36133 9.35147C6.36133 9.17628 6.42406 9.02595 6.54954 8.90048C6.67501 8.77501 6.82534 8.71227 7.00053 8.71227C7.17572 8.71227 7.32605 8.77501 7.45153 8.90048C7.577 9.02595 7.63974 9.17628 7.63974 9.35147C7.63974 9.46748 7.61014 9.57401 7.55096 9.67108C7.49414 9.76814 7.4172 9.84627 7.32013 9.90545C7.22544 9.96227 7.1189 9.99068 7.00053 9.99068Z" fill={props.color ?? "white"}/>
    </svg>
  );
};

export default memo(WarningIcon);
